"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOUNDARY_CLASS_OC = exports.BOUNDARY_CLASS_AMR = void 0;
exports.BOUNDARY_CLASS_AMR = 'ic.amr';
exports.BOUNDARY_CLASS_OC = 'ic.ec';
//# sourceMappingURL=resolution-view.js.map